import { useEffect, useCallback } from 'react';
import { withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import { updateErrors } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';

import { JsonTextAreaField } from '../../CustomComponents/JsonTextAreaField';

const JsonTextAreaControl = ({
  data,
  handleChange,
  path,
  label,
  required,
  schema,
}: ControlProps) => {
  const { dispatch } = useJsonForms();

  const sendError = useCallback(
    (errorMessage: string | null) => {
      dispatch?.(
        updateErrors(
          errorMessage
            ? [
                {
                  message: errorMessage,
                  instancePath: path.startsWith('/') ? path : `/${path}`,
                  keyword: 'custom',
                  schemaPath: '',
                  params: {},
                },
              ]
            : []
        )
      );
    },
    [dispatch, path]
  );

  useEffect(() => {
    sendError(null);
  }, [sendError]);

  const options = (schema as any)?.['x-options'] || {};

  return (
    <JsonTextAreaField
      value={data}
      label={label}
      helperText={(schema as any)?.helperText}
      required={required}
      onChange={(newValue, error) => {
        handleChange(path, newValue);
        sendError(error);
      }}
      classes={options?.classes}
    />
  );
};

export default withJsonFormsControlProps(JsonTextAreaControl);
